import React, { Component } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Select, Button, Spin } from "antd";
import moment from "moment";
import fetchHandler from "@/fetch/fetchHandler";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { upgrade, getFirmwareList, stubCmdFirmware } from "@/fetch/fetchApi";

const defaultDate = moment();
@monthPickerHoc
class frameWorkUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridData: [],
      exportMes: "导出",
      option: [],
      primaryState: true,
      seconds: 11,
      btnLoading: false,
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubIdData,
      page: 1,
    };
    this.interval = null;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getFrameWork();
  }

  // 点击获取最新版本
  getSeconds = () => {
    this.setState({
      btnLoading: true,
    });
    console.log(this.props.stubId);
    fetchHandler(stubCmdFirmware, {
      stubId: this.props.stubId,
    }).then((res) => {
      this.setState({
        btnLoading: false,
      });
      if (res && (res.code === "success" || res.code === "ok")) {
        // 设置计时器
        this.interval = setInterval(() => {
          const seconds = this.state.seconds - 1;
          if (seconds < 0) {
            clearInterval(this.interval);
            this.getFrameWork();
          } else {
            this.setState({
              seconds: seconds,
            });
          }
        }, 1000);
      }
    });
  };

  // 获取固件版本
  getFrameWork() {
    this.setState({
      spinning: true,
      seconds: 11,
    });

    fetchHandler(getFirmwareList, {
      frameType: this.props.frameType,
    }).then((res) => {
      console.log(res);
      const option = res.data.map((item) => {
        const foo = {
          text: `${item.frameWork}(${item.desc})`,
          value: item.frameWork,
        };
        return foo;
      });

      this.setState({
        option: [...option],
        spinning: false,
      });
    });
  }

  // 固件升级
  frameWorkUpdate() {
    fetchHandler(upgrade, {
      stubId: this.props.stubId,
      frameType: this.props.frameType,
      frameWork: this.state.frameWork,
    }).then((res) => {
      console.log(res);

      if (res && res.code === "success") {
        this.props.frameWorkUpdateFunc();
      } else {
        this.props.errorHandler();
      }
    });
  }

  // 点击刷新操作
  refreshCurrent = () => {
    // 清楚计时器
    clearInterval(this.interval);
    this.props.updateFramType();
    // 获取最新版本
    this.getFrameWork();
  };

  init() {}

  setFrameWork = (value) => {
    console.log(value);
    this.setState({
      frameWork: value,
      primaryState: false,
    });
  };

  frameWorkUpdateFunc() {
    if (this.state.frameWork) {
      this.frameWorkUpdate();
    }
  }

  render() {
    console.log("1-----------------");
    return (
      <Form className="login-form update-frame-work-modal">
        <Spin spinning={this.state.spinning}>
          <Form.Item
            initialValue={this.props.frameWork}
            label="固件版本:"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}>
            <Select placeholder="请选择" onChange={this.setFrameWork}>
              {this.state.option.map((item) => {
                return <option value={item.value}> {item.text}</option>;
              })}
            </Select>
          </Form.Item>
          <div className="refresh-btn">
            <Button
              loading={this.state.btnLoading}
              disabled={this.state.seconds <= 10 && this.state.seconds >= 0}
              className="refresh-item"
              onClick={this.getSeconds}>
              获取设备最新版本
            </Button>
            {this.state.seconds <= 10 && this.state.seconds >= 0 && (
              <div className="tips">
                设备固件版本获取中，请过{this.state.seconds}秒后
                <a onClick={this.refreshCurrent}>刷新</a>查看！
              </div>
            )}
          </div>
          <Form.Item
            label="固件信息："
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}
            style={{ display: this.state.btnDisplay }}>
            {this.props.frameType}-{this.props.frameWork}
          </Form.Item>

          <Form.Item wrapperCol={{ span: 15, offset: 5 }} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              disabled={this.state.primaryState}
              onClick={() => {
                this.frameWorkUpdateFunc();
              }}>
              确定
            </Button>
            <Button type="default" onClick={this.props.onCancel} style={{ marginLeft: "20px" }}>
              取消
            </Button>
          </Form.Item>
        </Spin>
      </Form>
    );
  }
}

export default frameWorkUpdate;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/frameWorkUpdate.js